<template>
  <div
    v-loading.fullscreen.lock="fullscreenLoading"
    class="main-tracking-detail">
    <el-button
      v-if="profile.role !== 'gerente_dealer'"
      circle
      class="btn-add"
      type="primary"
      style="padding: 7px"
      @click="addTracing">
      <i
        class="icon-plus"
        type="danger"/>
    </el-button>
    <track-container
      :trackings="trackings"
      :opportunity="opportunity"
      @editTrack="editTrack"
      @checkComplete="checkComplete"/>
  </div>
</template>

<script>
import TrackContainer from './track-container'
export default {
  name: 'TracingsDetailItem',
  components: { TrackContainer },
  props: {
    opportunity: {
      type: Object,
      default: null
    },
    trackings: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      fullscreenLoading: false
    }
  },
  computed: {
    profile () {
      return this.$store.getters['profile/me']
    }
  },
  methods: {
    addTracing () {
      this.$emit('newTracing')
    },
    editTrack (id, final) {
      this.$store.dispatch('trackings/get', {id: id}).then(response => {
        this.$emit('newTracing', true, final)
      }).catch(e => {
        console.log(e)
      })
    },
    checkComplete (track) {
      this.fullscreenLoading = true
      let clone = Object.assign({}, track)
      clone.completed = !clone.completed
      this.$store.dispatch('trackings/save', clone)
        .then(response => {
          this.$store.dispatch('trackings/query', {
            'filters[where][opportunityId][eq]': this.opportunity.id,
            sort: 'dueDate asc',
            limit: 1000
          })
            .finally(() => {
              this.$message.success('El seguimiento ha sido actualizado con éxito')
              this.fullscreenLoading = false
            })
        })
        .catch(e => {
          this.fullscreenLoading = false
          this.$message.error('El seguimiento no pudo ser actualizado')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.main-tracking-detail {
  position: relative;
  padding: 30px;
  .btn-add {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 100;
    box-shadow: 0 3px 6px rgba(#E7120E, 0.26);
    i {
      font-size: 23px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/trackings/trackings-detail-item.vue